// JOBE-0105: ScopeToggle — 4-state segmented control for the projects
// index page. Maps 1:1 onto `?scope=mine|watching|department|org`
// (JOBE-0104). Single-select; default value `mine` is URL-omitted
// per JOBE-0104's defaults-to-mine contract.
//
// Spec §Decision 1.

import React from 'react';

export const SCOPE_OPTIONS = [
  { value: 'mine', label: 'Mine' },
  { value: 'watching', label: 'Watching' },
  { value: 'department', label: 'Department' },
  { value: 'org', label: 'Org' },
];

export function ScopeToggle({ value, onChange }) {
  const active = SCOPE_OPTIONS.find((o) => o.value === value) ? value : 'mine';
  return (
    <div
      className="projects-scope-toggle"
      role="radiogroup"
      aria-label="Project scope"
      data-testid="projects-scope-toggle"
    >
      {SCOPE_OPTIONS.map((opt) => {
        const selected = opt.value === active;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            data-testid={`projects-scope-${opt.value}`}
            className={`projects-scope-button${selected ? ' projects-scope-button-active' : ''}`}
            onClick={() => {
              if (selected) return;
              onChange(opt.value);
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
